/**
 * Radio Groups Component.
 * Its Wrapper Component for Kepler `Radio` Component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormField from 'kepler/lib/components/FormField';
import Radio from 'kepler/lib/components/Radio';

class RadioGroups extends Component {
  // Set the Field Settings and Error as States.
  constructor(props) {
    super(props);

    this.state = {
      options: props.options,
      errors: [],
    };
  }

  // Every Component Re-render with New Props
  // This will update the Field Settings and validate according to the prop change during Topic Tree Selection.
  componentWillReceiveProps(props) {
    this.setState({
      options: props.options,
    });
  }

  // Triggers, When checkbox clicked.
  handleClick(e) {
    if (e.target.checked) {
      const options = this.state.options;
      options.value = e.target.value;

      this.setState({
        options,
      });

      this.setFormState();
    }
  }

  // Return List of Radio buttons as per state `options`.
  getOptions() {
    const options = this.props.options.options;
    return options.map((option) => {
      const isSelected = (this.props.options.value === option.value);
      return (
        <Radio
          onClick={(e) => this.handleClick(e)}
          key={option.label}
          name={this.props.options.id}
          label={option.label}
          value={option.value}
          checked={isSelected}
        />
      );
    });
  }

  // Send the Field State to Form.
  setFormState() {
    const options = this.state.options;
    this.props.handleValue(options);
  }

  // Render the `RadioGroup` Component.
  render() {
    return (
      <FormField label={this.props.options.label}>
        {this.getOptions()}
      </FormField>
    );
  }
}

// RadioGroups Props Types.
RadioGroups.propTypes = {

  // Complex Props.
  options: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    isRequired: PropTypes.bool,
    hasError: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      default: PropTypes.bool,
    })),
  }),

  // Method Props.
  handleValue: PropTypes.func.isRequired,
};

// RadioGroups Props default values.
RadioGroups.defaultProps = {
  validate: false,
  options: {},
};

export default RadioGroups;
